import { hubApi } from '@/api';
import * as filterOption from '@/lib/query-parameter/filter';
import { desc, injectSortParamHelper, } from '@/lib/query-parameter/sortby';
import QueryParameterBuilder from '@/lib/query-parameter/QueryParameterBuilder';
import { field, embed, embedField, } from '@/lib/query-parameter/resource';
import { ALL_STORE_ID } from '@/constants/global';
import PaginationOutput from '@/helpers/PaginationOutput';
const { orOperator, include, notEquals, between, equals, injectFilterParamHelper, isNull, } = filterOption;
export default {
    async getHubInfo() {
        const params = new QueryParameterBuilder()
            .addFields(field('latitude', 'longitude', 'distributorId', 'code', 'headYn', 'name', 'addChargeApplyYn', 'workerBulletin', 'addDeliveryCharge', 'addDeliveryChargeRate', 'addCookingTime', 'deliveryWorkYn', 'phone', 'useYn'))
            .addEmbeds(embed('distributor'))
            .addFields(embedField('distributor', 'name'))
            .addEmbeds(embed('hubConfiguration'));
        const response = await hubApi.getHubsMe(params.build());
        return response.data;
    },
    /**
     * 현재는 허브정산에서만 쓰이고 있음
     * @param hubId
     */
    async getSelectedHubInfo(hubId = '') {
        const params = new QueryParameterBuilder()
            .addFields(field('businessName', 'businessNumber', 'ceoName', 'ceoEmail', 'businessCondition', 'businessType', 'addressSiDo', 'addressSiGunGu', 'addressDong', 'addressLi', 'addressJibun', 'addressRoad', 'addressBuildingNumber', 'addressBuildingName', 'addressDetail'));
        const response = await hubApi.getHub(hubId, params.build());
        return response.data;
    },
    // TODO getHubs -> getHubList로 복수형 변수명 컨벤션으로 변경 필요
    // https://github.com/barogo/hub-control-room/pull/1638#discussion_r1286503097
    async getHubs({ pageNumber = 1, pageSize = 20, useYn = 'Y', } = {
        pageNumber: 1,
        pageSize: 20,
        useYn: 'Y',
    }) {
        const params = new QueryParameterBuilder()
            .addFilters(equals('useYn', useYn))
            .addFields(field('distributorId', 'code', 'headYn', 'name', 'addChargeApplyYn', 'workerBulletin', 'addDeliveryCharge', 'addDeliveryChargeRate', 'addCookingTime', 'deliveryWorkYn'))
            .addPageNumber(pageNumber)
            .addPageSize(pageSize);
        const response = await hubApi.getHubList(params.build());
        return PaginationOutput.adaptorFactory(response);
    },
    async getHub(hubId = '') {
        const response = await hubApi.getHub(hubId);
        return response.data;
    },
    // 구역설정
    async getSubscribeHubCoordinate(hubId = '') {
        const params = new QueryParameterBuilder()
            .addFields(field('longitude', 'latitude'));
        const response = await hubApi.getHub(hubId, params.build());
        return response.data;
    },
    async applyAddCharge({ hubId, applyYn, reason }) {
        const data = {
            job: 'APPLY_ADD_DELIVERY_CHARGE',
            storeIds: [
                ALL_STORE_ID,
            ],
            applyYn,
            memo: reason,
            expectHubYn: 'Y',
        };
        const response = await hubApi.putHubConfiguration(hubId, data);
        return response.data;
    },
    async addDeliveryCharge({ hubId, charge, chargeRate, reason, }) {
        const data = {
            job: 'ADD_DELIVERY_CHARGE',
            storeIds: [
                ALL_STORE_ID,
            ],
            charge,
            chargeRate,
            memo: reason,
        };
        const response = await hubApi.putHubConfiguration(hubId, data);
        return response.data;
    },
    async updateWorkerBulletin({ hubId, bulletin }) {
        const data = {
            job: 'BULLETIN',
            memo: '',
            bulletin,
        };
        const response = await hubApi.putHubConfiguration(hubId, data);
        return response.data;
    },
    // 라이더 관리 자동 차감 그룹 (C,R,U,D)
    async postWorkerCashAutoDeductGroup({ hubId, payload }) {
        const data = {
            name: payload.name,
        };
        const response = await hubApi.postWorkerCashAutoDeductGroup(hubId, data);
        return response.data;
    },
    async getWorkerCashAutoDeductGroup({ hubId }) {
        const params = new QueryParameterBuilder()
            .addSortBy(desc('name'))
            .build();
        const response = await hubApi.getWorkerCashAutoDeductGroup(hubId, params);
        return response.data;
    },
    async putWorkerCashAutoDeductGroup({ hubId, id, payload }) {
        const data = {
            name: payload.name,
        };
        const response = await hubApi.putWorkerCashAutoDeductGroup(hubId, id, data);
        return response.data;
    },
    async deleteWorkerCashAutoDeductGroup({ hubId, id }) {
        const response = await hubApi.deleteWorkerCashAutoDeductGroup(hubId, id);
        return response.data;
    },
    // 라이더 관리 자동 차감 그룹 라이더 등록
    async postWorkerCashAutoDeductGroupRegister({ hubId, groupId, payload }) {
        const data = {
            registers: payload.registers,
            unregisters: payload.unregisters,
        };
        const response = await hubApi.postWorkerCashAutoDeductGroupRegister(hubId, groupId, data);
        return response.data;
    },
    // 라이더 관리 자동 차감 그룹 스케줄 설정 (C,R,U,D)
    async postWorkerCashAutoDeductGroupOption({ hubId, groupId, payload }) {
        const data = {
            scheduleName: payload.scheduleName,
            scheduleType: payload.scheduleType,
            amount: payload.amount,
            accountByWorker: payload.accountByWorker,
            fromAt: payload.fromAt,
            toAt: payload.toAt,
            memo: payload?.memo,
        };
        const response = await hubApi.postWorkerCashAutoDeductGroupOption(hubId, groupId, data);
        return response.data;
    },
    async getWorkerCashAutoDeductGroupOption({ hubId, groupId }) {
        const params = new QueryParameterBuilder()
            .build();
        const response = await hubApi.getWorkerCashAutoDeductGroupOption(hubId, groupId, params);
        return response.data;
    },
    async putWorkerCashAutoDeductGroupOption({ hubId, groupId, id, payload, }) {
        const data = {
            scheduleName: payload.scheduleName,
            scheduleType: payload.scheduleType,
            amount: payload.amount,
            accountByWorker: payload.accountByWorker,
            fromAt: payload.fromAt,
            toAt: payload.toAt,
            memo: payload?.memo,
        };
        const response = await hubApi.putWorkerCashAutoDeductGroupOption(hubId, groupId, id, data);
        return response.data;
    },
    async deleteWorkerCashAutoDeductGroupOption({ hubId, groupId, id }) {
        const response = await hubApi.deleteWorkerCashAutoDeductGroupOption(hubId, groupId, id);
        return response.data;
    },
    // 라이더 관리 배달대행료 수수료 그룹 (C,R,U,D)
    async postWorkerDeliveryFeeGroup({ hubId, payload }) {
        const data = {
            name: payload.name,
            dayFeeCount: payload.dayFeeCount,
        };
        const response = await hubApi.postWorkerDeliveryFeeGroup(hubId, data);
        return response.data;
    },
    async getWorkerDeliveryFeeGroup({ hubId }) {
        const params = new QueryParameterBuilder()
            .addSortBy(desc('name'))
            .build();
        const response = await hubApi.getWorkerDeliveryFeeGroup(hubId, params);
        return response.data;
    },
    async putWorkerDeliveryFeeGroup({ hubId, id, payload }) {
        const data = {
            name: payload.name,
            dayFeeCount: payload.dayFeeCount,
        };
        const response = await hubApi.putWorkerDeliveryFeeGroup(hubId, id, data);
        return response.data;
    },
    async deleteWorkerDeliveryFeeGroup({ hubId, id }) {
        const response = await hubApi.deleteWorkerDeliveryFeeGroup(hubId, id);
        return response.data;
    },
    // 라이더 관리 배달대행료 수수료 그룹 라이더 등록
    async postWorkerDeliveryFeeGroupRegister({ hubId, groupId, payload }) {
        const data = {
            registers: payload.registers,
            unregisters: payload.unregisters,
        };
        const response = await hubApi.postWorkerDeliveryFeeGroupRegister(hubId, groupId, data);
        return response.data;
    },
    // 라이더 관리 배달대행료 수수료 설정 (C,R,U,D)
    async postWorkerDeliveryFeeGroupOption({ hubId, groupId, payload }) {
        const data = {
            fromAmount: payload.fromAmount,
            toAmount: payload.toAmount,
            fee: payload.fee,
            rate: payload.rate,
        };
        const response = await hubApi.postWorkerDeliveryFeeGroupOption(hubId, groupId, data);
        return response.data;
    },
    async getWorkerDeliveryFeeGroupOption({ hubId, groupId }) {
        const params = new QueryParameterBuilder()
            .build();
        const response = await hubApi.getWorkerDeliveryFeeGroupOption(hubId, groupId, params);
        return response.data;
    },
    async putWorkerDeliveryFeeGroupOption({ hubId, groupId, id, payload, }) {
        const data = {
            fromAmount: payload.fromAmount,
            toAmount: payload.toAmount,
            fee: payload.fee,
            rate: payload.rate,
        };
        const response = await hubApi.putWorkerDeliveryFeeGroupOption(hubId, groupId, id, data);
        return response.data;
    },
    async deleteWorkerDeliveryFeeGroupOption({ hubId, groupId, id }) {
        const response = await hubApi.deleteWorkerDeliveryFeeGroupOption(hubId, groupId, id);
        return response.data;
    },
    // 상점 관리 상점 그룹별 배달대행료 수수료 그룹 (C,R,U,D)
    async postWorkerFeePerStoreGroup({ hubId, payload }) {
        const data = {
            name: payload.name,
            dayFeeCount: payload.dayFeeCount,
        };
        const response = await hubApi.postWorkerFeePerStoreGroup(hubId, data);
        return response.data;
    },
    async getWorkerFeePerStoreGroup({ hubId }) {
        const params = new QueryParameterBuilder()
            .addSortBy('name')
            .build();
        const response = await hubApi.getWorkerFeePerStoreGroup(hubId, params);
        return response.data;
    },
    async putWorkerFeePerStoreGroup({ hubId, groupId, payload }) {
        const data = {
            name: payload.name,
            dayFeeCount: payload.dayFeeCount,
        };
        const response = await hubApi.putWorkerFeePerStoreGroup(hubId, groupId, data);
        return response.data;
    },
    async deleteWorkerFeePerStoreGroup({ hubId, groupId }) {
        const response = await hubApi.deleteWorkerFeePerStoreGroup(hubId, groupId);
        return response.data;
    },
    // 상점 배달대행수수료 그룹 매핑 정보 조회
    async getWorkerFeePerStoreGroupStoreList({ groupId, hubId, type }) {
        const params = new QueryParameterBuilder()
            .addPageSize(1000)
            .add('storeCategoryType', type)
            .add('isRegistered', true)
            .addEmbeds(embed('WORKER_FEE_PER_STORE_GROUP'));
        const response = await hubApi.getWorkerFeePerStoreGroupStoreList(hubId, groupId, params.build());
        return response.data;
    },
    async getWorkerFeePerStoreGroupAvailableStoreList({ groupId, hubId, type }) {
        const params = new QueryParameterBuilder()
            .addPageSize(1000)
            .add('storeCategoryType', type)
            .add('isRegistered', false)
            .addEmbeds(embed('WORKER_FEE_PER_STORE_GROUP'));
        const response = await hubApi.getWorkerFeePerStoreGroupStoreList(hubId, groupId, params.build());
        return response.data;
    },
    // 상점 배달대행수수료 그룹 상점 등록/삭제
    async putWorkerFeePerStoreGroupStoreList({ hubId, groupId, payload }) {
        const data = {
            registers: payload.registers,
            unRegisters: payload.unregisters,
        };
        const response = await hubApi.putWorkerFeePerStoreGroupStoreList(hubId, groupId, data);
        return response.data;
    },
    // 상점 관리 상점 그룹별 배달대행료 수수료 설정 (C,R,U,D)
    async postWorkerFeePerStoreGroupOption({ hubId, groupId, payload }) {
        const data = {
            fromAmount: payload.fromAmount,
            toAmount: payload.toAmount,
            fee: payload.fee,
            rate: payload.rate,
        };
        const response = await hubApi.postWorkerFeePerStoreGroupOption(hubId, groupId, data);
        return response.data;
    },
    async getWorkerFeePerStoreGroupOption({ hubId, groupId }) {
        const params = new QueryParameterBuilder()
            .addSortBy(desc('fromAmount'))
            .build();
        const response = await hubApi.getWorkerFeePerStoreGroupOption(hubId, groupId, params);
        return response.data;
    },
    async putWorkerFeePerStoreGroupOption({ hubId, groupId, optionId, payload, }) {
        const data = {
            fromAmount: payload.fromAmount,
            toAmount: payload.toAmount,
            fee: payload.fee,
            rate: payload.rate,
        };
        const response = await hubApi.putWorkerFeePerStoreGroupOption(hubId, groupId, optionId, data);
        return response.data;
    },
    async deleteWorkerFeePerStoreGroupOption({ hubId, groupId, optionId }) {
        const response = await hubApi.deleteWorkerFeePerStoreGroupOption(hubId, groupId, optionId);
        return response.data;
    },
    // 배차 취소 패널티 그룹 (C,R,U,D)
    async postWorkerAllocatedCancelPenaltyGroup({ hubId, payload, }) {
        const data = {
            name: payload.name,
        };
        const response = await hubApi.postWorkerAllocatedCancelPenaltyGroup(hubId, data);
        return response.data;
    },
    async getWorkerAllocatedCancelPenaltyGroup({ hubId, }) {
        const params = new QueryParameterBuilder()
            // .addSortBy(desc('name'))
            .build();
        const response = await hubApi.getWorkerAllocatedCancelPenaltyGroup(hubId, params);
        return response.data;
    },
    async putWorkerAllocatedCancelPenaltyGroup({ hubId, payload, id, }) {
        const data = {
            name: payload.name,
        };
        const response = await hubApi.putWorkerAllocatedCancelPenaltyGroup(hubId, id, data);
        return response.data;
    },
    async deleteWorkerAllocatedCancelPenaltyGroup({ hubId, id, }) {
        const response = await hubApi.deleteWorkerAllocatedCancelPenaltyGroup(hubId, id);
        return response.data;
    },
    // 배차 취소 패널티 그룹 라이더 등록
    async postWorkerAllocatedCancelPenaltyGroupWorkerList({ hubId, groupId, payload }) {
        const data = {
            registers: payload.registers,
            unregisters: payload.unregisters,
        };
        const response = await hubApi.postWorkerAllocatedCancelPenaltyGroupWorkerList(hubId, groupId, data);
        return response.data;
    },
    // 배차 취소 패널티 그룹 상세 (R,U)
    async getWorkerAllocatedCancelPenaltyGroupDetail({ hubId, groupId, }) {
        const params = new QueryParameterBuilder()
            .build();
        const response = await hubApi.getWorkerAllocatedCancelPenaltyGroupDetail(hubId, groupId, params);
        return response.data;
    },
    async putWorkerAllocatedCancelPenaltyGroupDetail({ hubId, groupId, id, payload, }) {
        const data = {
            penaltyAmount: payload.penaltyAmount,
            penaltyStartCount: payload.penaltyStartCount,
        };
        const response = await hubApi.putWorkerAllocatedCancelPenaltyGroupDetail(hubId, groupId, id, data);
        return response.data;
    },
    /**
     * 공유 받은 공유 정보 조회
     * @returns
     */
    async getAgencyShareInfo({ hubId, pageNumber = 1, pageSize = 10_000 }) {
        const params = new QueryParameterBuilder()
            .addFields(field('distributorId', 'hubId', 'storeId', 'useYn', 'shareDisplayYn', 'shareDelaySecond'))
            .addSortBy(desc('storeId'))
            .addPageNumber(pageNumber)
            .addPageSize(pageSize)
            .build();
        const response = await hubApi.getAgencyShareInfo(hubId, params);
        return PaginationOutput.adaptorFactory(response);
    },
    async getOperationSettingHistories({ hubId = '', betweenDate = {}, pageNumber = 1, pageSize = 10_000, filters = [], processTypes = [], }) {
        const params = new QueryParameterBuilder()
            .addFilters(between(betweenDate))
            // 필수 비노출 필터
            .addFilters(include('processType', ...processTypes))
            .addFilters(orOperator(isNull('memo'), notEquals('memo', '메인허브-자동적용')))
            .addFilters(orOperator(isNull('processMemo'), notEquals('processMemo', '초기화')))
            .addFields(field('logId', 'createdBy', 'createdAt', 'memo', 'hubId', 'storeId', 'agencyHubId', 'processType', 'processedAt', 'processResult', 'processedBy', 'addTime', 'processMemo', 'popupCount', 'changeAddAmount', 'changeAddRate'))
            .addSortBy(desc('createdAt'))
            .addPageNumber(pageNumber)
            .addPageSize(pageSize)
            .addEmbeds(embed('store'));
        injectFilterParamHelper(params, filters);
        const response = await hubApi.getOperationSettingHistories(hubId, params.build());
        return PaginationOutput.adaptorFactory(response);
    },
    postOperationSetting(formDto) {
        return hubApi.postOperationSetting(formDto);
    },
    async getHubManagementList({ filters = [], sortOption = [], pageNumber = 1, pageSize = 100, hubId = '', }) {
        const params = new QueryParameterBuilder()
            .addPageNumber(pageNumber)
            .addPageSize(pageSize)
            .addEmbeds(embed('VIRTUAL_BANK', 'HUB_DEPOSIT_CASH'));
        if (hubId) {
            params.addFilters(include('code', hubId));
        }
        injectFilterParamHelper(params, filters);
        injectSortParamHelper(params, sortOption);
        const response = await hubApi.getHubList(params.build());
        return PaginationOutput.adaptorFactory(response);
    },
    async getManagementHub(hubId = '') {
        const params = new QueryParameterBuilder()
            .addFields(field('addChargeApplyYn', 'baromoney', 'deliveryWorkYn', 'addCookingTime', 'name', 'code', 'distributorId', 'callcenterCode', 'masterId', 'addressSiDo', 'addressSiGunGu', 'addressDong', 'addressLi', 'addressJibun', 'addressRoad', 'addressBuildingNumber', 'addressBuildingName', 'addressDetail', 'hubRepresentativePhone', 'phone', 'fax', 'useYn', 'workingTime', 'depositBaromoney', 'businessNumber', 'businessName', 'ceoName', 'ceoEmail', 'ceoPhone', 'businessCondition', 'businessType', 'workerOneClickBaechaYn', 'laterUseYn', 'distanceProduct', 'createdAt', 'latitude', 'longitude', 'withdrawalBankCode', 'withdrawalBankAccount', 'withdrawalBankOwner'))
            .addEmbeds(embed('HUBCONFIGURATION', 'DISTRIBUTOR', 'VIRTUAL_BANK', 'HUB_DEPOSIT_CASH', 'WITHDRAW_BANK', 'HUB_ADJUSTMENT_RATE', 'HEADQUARTER_ADJUSTMENT_RATE'));
        const response = await hubApi.getHub(hubId, params.build());
        return response.data;
    },
    async postHub(data) {
        const response = await hubApi.postHub(data);
        return response.data;
    },
    async putHubInfo(hubId = '', type = 'basic', data) {
        const response = await hubApi.putHubInfo(hubId, type, data);
        return response.data;
    },
    async isHubRepresentativePhoneExist({ hubRepresentativePhone, hubId }) {
        const response = await hubApi.postHubRepresentativePhoneExistence({
            hubRepresentativePhone,
            hubId,
        });
        return response.data;
    },
};
